import guid from './generate-guid';

const CustomClientIdLocalStorageKey = 'ActionButton_Widget_CustomClientId';

function saveClientId(clientId) {
    try {
        localStorage.setItem(CustomClientIdLocalStorageKey, clientId);
    } catch (error) {
        return error;
    }
    return null;
}

function getClientId() {
    let clientId = null;

    try {
        clientId = localStorage.getItem(CustomClientIdLocalStorageKey);
        if (clientId != null) return clientId;
    } catch (error) {
        clientId = null;
    }

    if (clientId != null) return clientId;

    clientId = guid();
    saveClientId(clientId);
    return clientId;
}

const customClientId = getClientId();

export default customClientId;
